import { getError } from "@/utils/helpers";
import changeService from "@/services/Change/changeService";

export const namespaced = true;

export const state = {
  changeSingle: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_CHANGESINGLE(state, changeSingle) {
    state.changeSingle = changeSingle;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getChange({ commit }, UserId) {
    commit("SET_LOADING", true);

    changeService
      .getChange(UserId)
      .then((response) => {
        commit("SET_CHANGESINGLE", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  changeSingle: (state) => {
    return state.changeSingle;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
